import { useEffect, useState, useRef } from "react";
import { Avatar, Button, Input, Modal, Tooltip } from "antd";
import { ShareAltOutlined, SendOutlined } from "@ant-design/icons";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import { FlagOutlined } from "@ant-design/icons";

import PlayerProfile from "../../assets/images/for-prodile-player.jpg";
import ShareImage from "../../assets/images/share-new-iconn.svg";
import LikeImage from "../../assets/images/like0icon--new.svg";
import ArrowsquareLeft from "../../assets/images/arrow-square-left.svg";
import ArrowUpImg from "../../assets/images/arrow-up-for-message.svg";
import ClockImage from "../../assets/images/clock-image.svg";
import CoinImage from "../../assets/images/header-coin-icon.svg";
import BasicGifImage from "../../assets/images/gift-new-image.svg";
import PremiumGifImage from "../../assets/images/plantinum--new-image.svg";
import RoyalGifImage from "../../assets/images/royal-new-image.svg";
import LoveGifImage from "../../assets/images/love-new-image.svg";
import StarGifImage from "../../assets/images/star-new-image.svg";
import DaimondGifImage from "../../assets/images/diamond-new-image.svg";
import CoinIcon from "../../assets/images/coin-image.svg";
import ArrowIcon from "../../assets/images/arrow-right.svg";
import CheckIcon from "../../assets/images/check-orange-image.svg";
import TumbnailImage from "../../assets/images/poadcasts-image.jpg";

import Main from "../../components/layout/Main";
import { useSocket, useSocketPlayStream, usePushComment } from "./useSocket";
import { getChannelName, isValidUrl } from "../../helper/functions";
import moment from "moment";
import { useAuth } from "../../context/AuthContext";
import { useWallet } from "../../context/WalletContext";
import { Severty, ShowToast } from "../../helper/toast";
import { reportAPI } from "../../services/api";

const giftOptions = [
  { label: "Basic Gift", icon: BasicGifImage, coins: 100 },
  { label: "Premium", icon: PremiumGifImage, coins: 150 },
  { label: "Royal", icon: RoyalGifImage, coins: 200 },
  { label: "Love", icon: LoveGifImage, coins: 250 },
  { label: "Star", icon: StarGifImage, coins: 300 },
  { label: "Diamond", icon: DaimondGifImage, coins: 500 },
];

const tags = ["Competitive", "Casual", "Tech", "Trends"];

const PodcastDetailPage = () => {
  const [newComment, setNewComment] = useState("");
  const [profile, setProfile] = useState();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [streamView, setStreamView] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const walletSummaryData = JSON.parse(localStorage.getItem("walletSummary"));
  const [selectedPlayerId, setSelectedPlayerId] = useState(null);
  const selectedGift = giftOptions[selectedIndex];
  const [tab, setTab] = useState("send-gift");
  const [isReportModalVisible, setIsReportModalVisible] = useState(false);
  const [reportReason, setReportReason] = useState("");
  const [submittingReport, setSubmittingReport] = useState(false);
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [selectedComment, setSelectedComment] = useState();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { getProfileById, followUser, unfollowUser } = useAuth();
  const { sendToken, loadWalletSummary } = useWallet();

  // Socket for leave event
  const socketRef = useRef(null);

  // ------------- connect to sockets ---------------
  const liveStreams = useSocket();
  const pushComment = usePushComment();
  const { viewers = [], history = [], streamPlayers } = useSocketPlayStream(id);
  const handleComment = () => {
    pushComment({ id, comment: newComment });
    setNewComment("");
  };

  // --------- handlers -----------
  const fetchProfile = async (id) => {
    try {
      const response = await getProfileById(id);
      if (response.status === 200) {
        setProfile(response.data);
      }
    } catch (error) {
      console.log("Error Ocurred when fetch profile", error);
    }
  };

  const handleReport = (comment) => {
    setIsReportModalVisible(true);
    setSelectedComment(comment);
  };

  const handleSubmitReport = async () => {
    if (!reportReason.trim()) {
      ShowToast("Please enter a reason for the report.", Severty.ERROR);
      return;
    }
    setSubmittingReport(true);
    try {
      const payload = {
        entityType: "livestream:comments",
        entityId: selectedComment.userId,
        reason: reportReason.trim(),
        severity: "medium",
        userId: userProfile._id,
      };

      const res = await reportAPI.createReport(payload);

      ShowToast(
        res?.message || "Report submitted successfully.",
        Severty.SUCCESS,
      );
      setIsReportModalVisible(false);
      setReportReason("");
    } catch (error) {
      const message =
        error?.message ||
        error?.msg ||
        error?.error ||
        "Failed to submit report.";
      ShowToast(message, Severty.ERROR);
    } finally {
      setSubmittingReport(false);
    }
  };

  //---------- follow user ------------
  const handleFollow = async (id, isFollowing) => {
    try {
      let response;
      if (isFollowing) {
        response = await unfollowUser(id);
      } else {
        response = await followUser(id);
      }
      if (response.status === 200) {
        ShowToast(response.message, Severty.SUCCESS);
        fetchProfile(id);
      }
    } catch (error) {
      console.log("Error Ocurred when fetch profile", error);
    }
  };

  //-------- Send gift ----------
  const handleSendGift = async () => {
    try {
      const response = await sendToken({
        recipient: selectedPlayerId,
        amount: selectedGift.coins,
        notes: `Sent ${selectedGift.coins} Token`,
      });
      if (response.success) {
        loadWalletSummary();

        setIsConfirmModalVisible(true);
      } else {
        setIsModalVisible(false);
      }
    } catch (error) {
      setIsModalVisible(false);
      console.log("Error occured while send gift in live stream ", error);
    }
  };

  // ---------- use effect -----------
  useEffect(() => {
    // fetchProfile(id);
    loadWalletSummary();
  }, []);

  useEffect(() => {
    if (!id) return;

    socketRef.current = io("http://103.189.173.7:3369", {
      // socketRef.current = io("http://localhost:3369", {
      query: { token: localStorage.getItem("token") },
    });

    socketRef.current.on("connect", () => {
      console.log("✅ Socket connected");
      socketRef.current.emit("livestream:join", { streamId: id });
    });

    // Remove existing listeners to prevent duplication
    socketRef.current.off("livestream:history");
    socketRef.current.on("livestream:history", (data) => {
      setStreamView(data); // triggers re-render
    });

    const emitLeaveEvent = () => {
      if (socketRef.current && id) {
        socketRef.current.emit("livestream:leave", { streamId: id });
        console.log("🟠 Emitted livestream:leave for:", id);
      }
    };

    window.addEventListener("beforeunload", emitLeaveEvent);

    return () => {
      emitLeaveEvent();
      window.removeEventListener("beforeunload", emitLeaveEvent);
      socketRef.current.off("livestream:history");
      socketRef.current.disconnect();
      socketRef.current = null;
    };
  }, [id]);

  // Log when streamView updates
  useEffect(() => {
    if (streamView) {
      console.log("🟢 streamView updated:", streamView);
    }
  }, [streamView]);

  // Detect route changes and emit leave event
  useEffect(() => {
    const emitLeaveEvent = () => {
      if (socketRef.current && id) {
        socketRef.current.emit("livestream:leave", {
          streamId: id,
        });
        console.log(
          "Emitted livestream:leave for streamId on route change:",
          id,
        );
      }
    };

    // Emit leave event when location changes (user navigates away)
    return () => {
      emitLeaveEvent();
    };
  }, [location.pathname, id]);

  return (
    <Main>
      <div className="podcast-detail-container">
        {/* Left Side: Video and Info */}
        <div className="leftside-side-main-comment">
          {!streamView || !streamView.currentStreamLink ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <p>No Stream Available</p>
            </div>
          ) : streamView.currentStreamLink.includes("twitch.tv") ? (
            <iframe
              src={`https://player.twitch.tv/?channel=${getChannelName(
                streamView.currentStreamLink,
              )}&parent=${window.location.hostname}&autoplay=false&muted=true`}
              width="100%"
              height="30%"
              frameBorder="0"
              allow="autoplay"
              allowFullScreen
            ></iframe>
          ) : streamView?.currentStreamLink?.includes("kick.com") ? (
            <iframe
              src={`https://player.kick.com/${getChannelName(
                streamView?.currentStreamLink,
              )}?autoplay=false&muted=true`}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay"
              allowFullScreen
            />
          ) : (
            <video
              src={streamView?.currentStreamLink}
              autoPlay
              muted
              controls
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}

          {/* ------------- Streamer Profile -------------- */}

          {/* Similar Lives */}
          <div className="send-gift-sections">
            <div className="orange-header orange-header-similar live-stream-send-gift-section-header">
              <div
                className={
                  tab === "send-gift" ? "live-stream-send-gift-tab" : ""
                }
                onClick={() => setTab("send-gift")}
              >
                Send Gifts
              </div>
              <div
                className={
                  tab === "similar-lives" ? "live-stream-send-gift-tab" : ""
                }
                onClick={() => setTab("similar-lives")}
              >
                Similar Lives
              </div>
            </div>
            {/* Live streams Section */}
            {tab === "similar-lives" && (
              <div className="for-live-video-grid right-side-main-comment12120 for-live-video-grid-inner_main120">
                {liveStreams && liveStreams.length > 0 ? (
                  liveStreams.map((item, index) => (
                    <div
                      key={index}
                      className="for-live-video-grid-inner  "
                      onClick={() =>
                        navigate(`/live-stream/send-gift/${item?.id}`)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div className="for-live-video-grid-inner-image for-live-video-grid-inner-image-livve">
                        {item?.streamLink?.includes("twitch.tv") ? (
                          <iframe
                            src={`https://player.twitch.tv/?channel=${getChannelName(
                              item?.streamLink,
                            )}&parent=${
                              typeof window !== "undefined"
                                ? window.location.hostname
                                : ""
                            }&autoplay=false&muted=true`}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="autoplay"
                            allowFullScreen
                          />
                        ) : item?.streamLink?.includes("kick.com") ? (
                          <iframe
                            src={`https://player.kick.com/${getChannelName(
                              item?.streamLink,
                            )}?autoplay=false&muted=true`}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="autoplay"
                            allowFullScreen
                          />
                        ) : (
                          <video
                            src={item?.streamLink}
                            autoPlay
                            muted
                            controls
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                        <span className="live-tag">{item?.status}</span>
                        <h5>
                          <img src={ClockImage} alt="clock" /> {item?.viewers}
                        </h5>
                      </div>

                      <div className="for-live-video-grid-footer">
                        <div className="player-profile">
                          <img src={PlayerProfile} alt={item?.name} />
                        </div>
                        <div className="for-player-text">
                          <h5>{item?.name}</h5>
                          <p>{item?.game?.name}</p>
                          <div className="for-player-tags">
                            {tags.map((tag, i) => (
                              <span key={i}>{tag}</span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>Similar live streams not available</p>
                )}
              </div>
            )}
            {/* Send - Gift Section */}
            {tab === "send-gift" && (
              <div className="right-side-main-comment12120">
                <div className="header-available-tokenn">
                  <h4>Available Tokens</h4>
                  <h5>
                    <img src={CoinImage} />{" "}
                    {Number(walletSummaryData?.wallet?.total_balance).toFixed(
                      2,
                    )}
                  </h5>
                </div>
                <div className="gift-cards-main">
                  <div className="gift-cards-grid">
                    {giftOptions && giftOptions.length > 0
                      ? giftOptions.map((item, i) => (
                          <div
                            key={i}
                            className={`gift-card ${
                              selectedIndex === i ? "gift-card-active" : ""
                            }`}
                            onClick={() => setSelectedIndex(i)}
                          >
                            <div className="gift-icon">
                              <img src={item.icon} />
                            </div>
                            <div className="gift-label">{item.label}</div>
                            <div className="gift-coins">
                              <img src={CoinImage} /> {item.coins}
                            </div>
                          </div>
                        ))
                      : "Gifts options not available"}
                  </div>

                  {/* ===== Players in Stream (show under Send Gift) ===== */}
                  <div className="players-stream-section">
                    <div className="header-available-tokenn">
                      <h4>Moderator</h4>
                    </div>

                    <div className="players-stream-list">
                      <div
                        className={`players-stream-card`}
                        // onClick={() => setSelectedPlayerId(p.playerId)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={() => {}}
                      >
                        <div className="players-stream-avatar">
                          <Avatar
                            src={
                              "https://www.freepik.com/free-photo/portrait-man-laughing_12478216.htm#fromView=keyword&page=1&position=11&uuid=ab7688e7-22ea-4549-883a-ad11f294b0ed&query=User+profile"
                            }
                            alt="moderator-image"
                          />
                        </div>
                        <div className="players-stream-info">
                          <div className="players-stream-name">Moderator</div>
                          <div className="players-stream-id">#102354</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="players-stream-section">
                    <div className="header-available-tokenn">
                      <h4>Stream Players</h4>
                      <h5>{streamPlayers.length} players</h5>
                    </div>

                    <div className="players-stream-list">
                      {streamPlayers && streamPlayers.length > 0 ? (
                        streamPlayers.map((p) => (
                          <div
                            key={p.playerId}
                            className={`players-stream-card ${
                              selectedPlayerId === p.playerId
                                ? "active-player"
                                : ""
                            }`}
                            onClick={() => setSelectedPlayerId(p.playerId)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={() => {}}
                          >
                            <div className="players-stream-avatar">
                              <Avatar src={p.profilePic} alt={p.name} />
                            </div>
                            <div className="players-stream-info">
                              <div className="players-stream-name">
                                {p.name}
                              </div>
                              <div className="players-stream-id">
                                #{String(p.playerId).slice(0, 6)}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No players available</p>
                      )}
                    </div>
                  </div>
                  <div className="send-gift-button-wrapper">
                    <Button
                      className="send-gift-button"
                      type="default"
                      disabled={
                        selectedIndex === null || selectedPlayerId === null
                      }
                      onClick={() => setIsModalVisible(true)}
                    >
                      Send Gift
                    </Button>

                    {/* Confirm Modal */}
                    <Modal
                      centered
                      width={452}
                      open={isModalVisible}
                      onCancel={() => setIsModalVisible(false)}
                      footer={false}
                    >
                      {selectedGift && (
                        <>
                          <div className="gift-icon">
                            <img src={selectedGift.icon} />
                          </div>
                          <div className="gift-text">
                            <h4>Send {selectedGift.label}?</h4>
                            <h5>
                              This will deduct{" "}
                              <span>{selectedGift.coins} tokens</span>
                            </h5>
                            <h6>
                              <img src={CoinImage} /> Current Balance:{" "}
                              {Number(
                                walletSummaryData?.wallet?.total_balance,
                              ).toFixed(2)}
                            </h6>
                            <h6>
                              <img src={ArrowIcon} /> New Balance:{" "}
                              {Number(
                                walletSummaryData?.wallet?.total_balance -
                                  selectedGift.coins,
                              ).toFixed(2)}
                            </h6>
                          </div>
                          <div className="modal-footer12">
                            <Button
                              className="light-button"
                              onClick={() => setIsModalVisible(false)}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="Fill-button"
                              onClick={() => {
                                handleSendGift();
                              }}
                            >
                              Confirm Send
                            </Button>
                          </div>
                        </>
                      )}
                    </Modal>

                    {/* Success Modal */}
                    <Modal
                      open={isConfirmModalVisible}
                      onCancel={() => setIsConfirmModalVisible(false)}
                      footer={false}
                      centered
                      width={452}
                    >
                      <div className="check-image-modal">
                        <img src={CheckIcon} />
                      </div>
                      <div className="gift-text">
                        <h4>Successfully sent</h4>
                        <h5>
                          You sent <span>{selectedGift?.label}</span> to{" "}
                          <span>Alen Walk</span> for{" "}
                          <span>{selectedGift?.coins} Tokens</span>
                        </h5>
                      </div>
                      <div className="modal-footer12">
                        <Button
                          className="Fill-button"
                          onClick={() => setIsConfirmModalVisible(false)}
                        >
                          OK
                        </Button>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Side: Comments */}
        <div className="right-side-main-comment">
          {/* Header */}
          <div className="right-side-main-comment-header">
            <div className="header-comment-count">
              <img src={ArrowsquareLeft} alt="Back" />
              Comments ({history.length})
            </div>
          </div>

          {/* Comments Body */}
          <div className="comment-chat-section-body">
            {history.map((comment, idx) => {
              console.log("comment--==", comment);
              return (
                <div
                  key={idx}
                  style={{ display: "flex", gap: 12, marginBottom: 20 }}
                >
                  <Avatar
                    src={
                      isValidUrl(comment.profilePic)
                        ? comment.profilePic
                        : TumbnailImage
                    }
                  />

                  <div className="comment-chat-details">
                    <div className="comment-chat-details-message">
                      <h5>{comment?.name || "Unknown"}</h5>
                      <p>{moment(comment?.timestamp).fromNow()}</p>
                    </div>
                    {/* Report Button */}
                    <Tooltip title="Report">
                      <Button
                        type="text"
                        icon={<FlagOutlined style={{ color: "white" }} />}
                        className="report-comment-button"
                        onClick={() => handleReport(comment)}
                      />
                    </Tooltip>
                    <p>{comment?.message}</p>
                  </div>
                </div>
              );
            })}

            {/* Send Message */}
            <div className="send-message-input">
              <Input
                placeholder="Write comment"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
              <Button
                className="chat-send-button Fill-button"
                disabled={!newComment.trim()}
                onClick={handleComment}
              >
                <img src={ArrowUpImg} alt="Send" />
              </Button>
            </div>
          </div>
        </div>

        {/* Report Livestream Modal */}
        <Modal
          open={isReportModalVisible}
          onCancel={() => {
            if (!submittingReport) {
              setIsReportModalVisible(false);
            }
          }}
          footer={false}
          centered
          title="Report livestream"
          width={452}
        >
          <p style={{ color: "white" }}>
            Please describe why you are reporting this livestream.
          </p>
          <Input.TextArea
            rows={4}
            value={reportReason}
            onChange={(e) => setReportReason(e.target.value)}
            placeholder="Enter your reason here"
          />
          <div className="modal-footer12" style={{ marginTop: 16 }}>
            <Button
              className="light-button"
              onClick={() => setIsReportModalVisible(false)}
              disabled={submittingReport}
            >
              Cancel
            </Button>
            <Button
              className="Fill-button"
              loading={submittingReport}
              onClick={handleSubmitReport}
            >
              Submit Report
            </Button>
          </div>
        </Modal>
      </div>
    </Main>
  );
};

export default PodcastDetailPage;
